import { render } from "./EditLiquidation5.vue?vue&type=template&id=c4174b18"
import script from "./EditLiquidation5.vue?vue&type=script&lang=js"
export * from "./EditLiquidation5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__